import { createGlobalStyle } from 'styled-components';
import getBackgroundImageStyles from '../../utils/getBackgroundImageStyles';
import { IConfigGeneral } from '../../types/config';

export interface IGlobaVariables {
  breakpoint: {
    sm: string;
    md: string;
    lg: string;
    xl: string;
    xxl: string;
  };
}

export const globalVariables: IGlobaVariables = {
  breakpoint: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px',
  },
};

const GlobalStyle = createGlobalStyle<{
  theme?: IGlobaVariables;
  config: IConfigGeneral;
}>`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  input,
  textarea,
  button,
  select,
  a {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  img {
    max-width: 100%;
    vertical-align: middle;
    border-style: none;
  }
  
  html {
      scroll-behavior: smooth;
  }

  body {
    font-family: ${({ config: { content } }) => content.text.fontFamily};
    font-weight: ${({ config: { content } }) => content.text.fontWeight};
    font-size: ${({ config: { content } }) => content.text.fontSize};
    color: ${({ config: { content } }) => content.text.color};;
    margin: 0;
    padding: 0;
    background-color: ${({ config: { content } }) => content.body.backgroundColor};
  }

  main{
    position: relative;
    & > * {
      position: relative;
    }
    background: ${({ config: { serviceBackgroundImage } }) =>
      serviceBackgroundImage?.boolean_showBackgroundImage === 'true'
        ? getBackgroundImageStyles(serviceBackgroundImage.backgroundImage)
        : 'none'};
    background-position: ${({ config: { serviceBackgroundImage } }) =>
      serviceBackgroundImage?.boolean_showBackgroundImage === 'true'
        ? `${serviceBackgroundImage.backgroundPositionX} ${serviceBackgroundImage.backgroundPositionY}`
        : 'auto'};
    background-repeat: ${({ config: { serviceBackgroundImage } }) =>
      serviceBackgroundImage?.boolean_showBackgroundImage === 'true'
        ? serviceBackgroundImage.backgroundRepeat
        : 'no-repeat'};
    background-size: ${({ config: { serviceBackgroundImage } }) =>
      serviceBackgroundImage?.boolean_showBackgroundImage === 'true'
        ? serviceBackgroundImage.backgroundSize
        : 'initial'};
        

    &::before {
      content: '';
      display: ${({ config: { serviceBackgroundImage } }) =>
        serviceBackgroundImage?.boolean_showBackgroundImage === 'true'
          ? serviceBackgroundImage.group_blenda.boolean_showBlenda === 'true'
            ? 'block'
            : 'none'
          : 'none'};
      position: absolute;
      display: block;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background:  ${({ config: { serviceBackgroundImage } }) =>
        serviceBackgroundImage?.boolean_showBackgroundImage === 'true'
          ? serviceBackgroundImage.group_blenda.backgroundColor
          : 'none'};
    }
  }

  a {
    color: ${({ config: { content } }) => content.link.color};
    text-decoration: ${({ config: { content } }) => content.link.textDecoration};
    font-style: ${({ config: { content } }) => content.link.fontStyle};
    transition: color 0.3s ease-in-out;

    &:hover {
        color: ${({ config: { content } }) => content.link.hover_color};
        text-decoration: ${({ config: { content } }) => content.link.hover_textDecoration};
    }
  }

  p, ul, ol, ol li, ul li {
    font-family: ${({ config: { content } }) => content.text.fontFamily};
    font-weight: ${({ config: { content } }) => content.text.fontWeight};
    font-size:${({ config: { content } }) => content.text.fontSize};
    font-style:${({ config: { content } }) => content.text.fontStyle};
    line-height: ${({ config: { content } }) => content.text.lineHeight};
    color: ${({ config: { content } }) => content.text.color};
    margin: ${({ config: { content } }) => content.text.margin};
  }

  h1 {
    font-family: ${({ config: { content } }) => content.h1.fontFamily};
    font-weight: ${({ config: { content } }) => content.h1.fontWeight};
    font-size:${({ config: { content } }) => content.h1.fontSize};
    line-height: ${({ config: { content } }) => content.h1.lineHeight};
    color: ${({ config: { content } }) => content.h1.color};
    margin: ${({ config: { content } }) => content.h1.margin};
    font-style: ${({ config: { content } }) => content.h1.fontStyle};
  }
  
  h2 {
    font-family: ${({ config: { content } }) => content.h2.fontFamily};
    font-weight: ${({ config: { content } }) => content.h2.fontWeight};
    font-size:${({ config: { content } }) => content.h2.fontSize};
    line-height: ${({ config: { content } }) => content.h2.lineHeight};
    color: ${({ config: { content } }) => content.h2.color};
    margin: ${({ config: { content } }) => content.h2.margin};
    font-style: ${({ config: { content } }) => content.h2.fontStyle};
  }

  h3 {
    font-family: ${({ config: { content } }) => content.h3.fontFamily};
    font-weight: ${({ config: { content } }) => content.h3.fontWeight};
    font-size:${({ config: { content } }) => content.h3.fontSize};
    line-height: ${({ config: { content } }) => content.h3.lineHeight};
    color: ${({ config: { content } }) => content.h3.color};
    margin: ${({ config: { content } }) => content.h3.margin};
    font-style: ${({ config: { content } }) => content.h3.fontStyle};
  }

  h4 {
    font-family: ${({ config: { content } }) => content.h4.fontFamily};
    font-weight: ${({ config: { content } }) => content.h4.fontWeight};
    font-size:${({ config: { content } }) => content.h4.fontSize};
    line-height: ${({ config: { content } }) => content.h4.lineHeight};
    color: ${({ config: { content } }) => content.h4.color};
    margin: ${({ config: { content } }) => content.h4.margin};
    font-style: ${({ config: { content } }) => content.h4.fontStyle};
  }

  .container {
    width: 1200px;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 15px;
  }
`;

export default GlobalStyle;
